var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"80px"},attrs:{"id":"app"}},[_c('navbar',{staticStyle:{"position":"fixed","top":"0","z-index":"1000","width":"100%"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }